import { Component, OnInit, HostListener } from '@angular/core';
import { CWSMSAPIService } from '../cwsmsapi.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatMenuTrigger, MatIconRegistry } from '@angular/material';
import { BuyCreditsComponent } from '../buy-credits/buy-credits.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-message-log',
  templateUrl: './message-log.component.html',
  styleUrls: ['./message-log.component.css']
})
export class MessageLogComponent implements OnInit {

	errorMessage: string = "";
	messageCredits: number = 0;
	sidemenuOpen: boolean = true;
	screenHeight: number;
	screenWidth: number;
	logEntries: any = [];
	loading: boolean = false;

	adminModeAvailable: boolean = false;
	adminMode: boolean = false;

	logEntriesPage: any = [];
	currentPageNumber: number = 1;
	maxPageNumber: number = 0;
	logEntriesPerPage: number = 50;
	logEntryPages: any = [];

	startDate: string = "";
	stopDate: string = "";

	constructor(public cwsms: CWSMSAPIService, public router: Router, private route: ActivatedRoute, public translate: TranslateService) {
		this.onResize();

		var d = new Date();
		this.stopDate = d.toISOString().split("T")[0];

		d.setDate(d.getDate()-30);
		this.startDate = d.toISOString().split("T")[0];
	}

	ngOnInit() {
		this.updateFilter();
	}

	toggleAdminMode() {
		this.adminMode = !this.adminMode;
		this.updateFilter();
	}

	adminUserClick(email) {
		if (confirm("Terminate user "+email+"?")) {
			this.cwsms.post('/admin/ban/'+email, {
				reason: "Your account has been terminated for breaking the Terms of Service (Spam/Phishing)."
			}, (err, data) => {
				if (err) {
					this.errorMessage = err.message;
				} else {
					alert("User "+email+" successfully banned!");
				}
			});
		}
	}

	adminApprove(id) {
		this.cwsms.get('/admin/audit/approve/'+id, (err, data) => {
			if (err) {
				this.errorMessage = err.message;
			} else {
				this.updateFilter();
			}
		});
	}

	adminDeny(id) {
		this.cwsms.get('/admin/audit/deny/'+id, (err, data) => {
			if (err) {
				this.errorMessage = err.message;
			} else {
				this.updateFilter();
			}
		});
	}

	nextPage() {
		if ((this.currentPageNumber-1) < this.maxPageNumber - 1) {
			this.currentPageNumber++;
			this.updatePagination();
		}
	}

	previousPage() {
		if ((this.currentPageNumber-1) > 0) {
			this.currentPageNumber--;
			this.updatePagination();
		}
	}

	onPaginationChange(val) {
		if (val === "" || isNaN(val)) {
			return;
		}

		setTimeout( () => {
			var newNum = parseInt(val);

			if (newNum < 1) {
				this.currentPageNumber = 1;
			} else if (newNum > this.maxPageNumber) {
				this.currentPageNumber = this.maxPageNumber;
			}

			this.updatePagination();
		}, 50)
	}

	updatePagination() {
		var offset = (this.currentPageNumber-1) * this.logEntriesPerPage;
		this.logEntriesPage = [];
		for (var i = offset; i < offset+this.logEntriesPerPage; i++) {
			if (this.logEntries[i] === undefined) {
				break;
			}
			this.logEntriesPage.push(this.logEntries[i]);
		}

		this.maxPageNumber = Math.ceil(this.logEntries.length/this.logEntriesPerPage);
		this.logEntryPages = Array.from(Array(this.maxPageNumber).keys());
	}

	updateFilter() {
		var startd = Math.floor(new Date(this.startDate).getTime()/1000);

		var actualStopDate = new Date(this.stopDate);
		actualStopDate.setDate(actualStopDate.getDate()+1);
		var stopd = Math.floor(actualStopDate.getTime()/1000);

		var pathPrefix = '/user';
		if (this.adminMode) {
			pathPrefix = '/admin';
		}

		this.loading = true;
		this.cwsms.get(pathPrefix+'/log/sms/'+startd+"/"+stopd, (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
				this.errorMessage = err.message;
			} else {
				this.logEntries = [];
				for (var entry of data) {
					entry.isoTime = new Date(entry.timestamp*1000).toISOString();
					entry.formattedTime = entry.isoTime.replace("T", " ").split(".")[0];

					if (!("messageStatus" in entry)) {
						entry.status = "Waiting";
						entry.statusBackground = "rgba(255,255,255,0.4)";
						entry.statusIcon = "hourglass.png";
					} else if (entry.messageStatus === "DELIVERED") {
						entry.statusBackground = "green";
						entry.status = "Delivered";
						entry.statusIcon = "check.png";
					} else if (entry.messageStatus === "ENROUTE") {
						entry.statusBackground = "orange";
						entry.status = "Enroute";
						entry.statusIcon = "hourglass.png";
					} else if (entry.messageStatus === "UNDELIVERABLE") {
						entry.statusBackground = "red";
						entry.status = "Undeliverable";
						entry.statusIcon = "warning.png";
					} else if (entry.messageStatus === "REJECTED") {
						entry.statusBackground = "red";
						entry.status = "Rejected";
						entry.statusIcon = "warning.png";
					} else if (entry.messageStatus === "EXPIRED") {
						entry.statusBackground = "red";
						entry.status = "Expired";
						entry.statusIcon = "warning.png";
					} else {
						entry.statusIcon = "hourglass.png";
						entry.statusBackground = "none";
						entry.status = entry.messageStatus;
					}
					this.logEntries.push(entry);
				}
				this.updatePagination();
				console.log(data);
			}
		});
	}

	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
		console.log(this.screenWidth+"x"+this.screenHeight);

		if (this.screenWidth < 720) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	toggleSidemenu() {
		if (this.sidemenuOpen) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	receivedSideMenuEvent(event) {
		if ("userData" in event) {
			this.messageCredits = parseFloat(event.userData.credits.N);

			if ("admin" in event.userData) {
				this.adminModeAvailable = true;
				this.adminMode = true;
				var d = new Date();
				d.setDate(d.getDate()-1);
				this.startDate = d.toISOString().split("T")[0];
				this.updateFilter();
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/message-log/message-log.component.ts